import axios from 'axios'
import responseInterceptor from '@/services/http/responseInterceptor'

export class Http {
  constructor() {
    this.axios = axios.create({
      withCredentials: true
    })
    this.axios.interceptors.response.use((response) => response, responseInterceptor)
    this.cancelToken = axios.CancelToken
    this.isCancel = axios.isCancel
  }

  get(url, params) {
    return this.axios.get(url, params)
  }

  post(url, data) {
    return this.axios.post(url, data)
  }

  postWithHeaders(url, data, headers) {
    return this.axios.post(url, data, { headers })
  }

  put(url, data) {
    return this.axios.put(url, data)
  }

  patch(url, data) {
    return this.axios.patch(url, data)
  }

  delete(url, params) {
    return this.axios.delete(url, params)
  }

  all(iterable) {
    return axios.all(iterable)
  }

  spread(callback) {
    return axios.spread(callback)
  }
}

export default new Http()
